/** PURE_IMPORTS_START .._.._Observable,.._.._operator_exhaustMap PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { exhaustMap } from '../../operator/exhaustMap';
Observable.prototype.exhaustMap = exhaustMap;
//# sourceMappingURL=exhaustMap.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/add/operator/exhaustMap.js
// module id = 669
// module chunks = 0